// src/pages/LoginPage.jsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Profile from "../components/Profile";

const LoginPage = () => {
  return (
    <>
      <Header />
      <Profile />
      <Footer />
    </>
  );
};

export default LoginPage;
